import { disable } from '@wix/ambassador-studio-v1-workspace/http'
import { retry, tryCatch } from '@wix/funnel-utils'

import { withMonitoring } from '../../monitoring/withMonitoring'
import { ambassadorHttpClient, isHttpError } from '../httpClient'

export const unmarkAsWixStudioAccount = () =>
  withMonitoring(
    () =>
      retry(async () => {
        const [error] = await tryCatch(() => ambassadorHttpClient.request(disable({})))
        if (error) {
          // If the feature is already disabled, it throws the next error, but it's success story for us, so we don't need to throw error and do retry
          if (isHttpError(error) && error.response?.data.message === 'Feature with name wix_studio not found') {
            return
          }
          throw error
        }
      }),
    'unmarkAsWixStudioAccount',
  )
